// extracted by mini-css-extract-plugin
export default {"addTenantNotice":"GyGwU5FZ0fz8nGXHUQGk","addTenant":"GIHdUmmQqVzQBtVruNZv","tenantFields":"aYAKtXbt537slHX3YGRt","pulse":"P7VDr0u403hLZoy7FO4A"};